import { utils as reducerUtils } from 'redux-rest-reducer';

import { ACTIONS } from '@~/actions/class-status';

import RestReducer from './reducer';

export default RestReducer(ACTIONS, (state, { type, payload }) => {
  switch (type) {
    case ACTIONS.INVALIDATE_ITEM:
      return reducerUtils.changeItemToStale(state, payload.id);
    default:
      return state;
  }
});
